import React from 'react';
import Slider from 'components/Slider/Slider'
import NavigateButtons from 'components/NavigateButtons/NavigateButtons';

const Main = () => {
  return (
    <div>
      <Slider />
      <NavigateButtons />
    </div>
  )
}

export default Main;